module.exports = __webpack_public_path__ + "static/media/clay.a35eba8c.jpg";